import type { LucideIcon } from 'lucide-react'
import {
  BookOpen,
  Download,
  FileText,
  Image,
  Layers,
  Map as MapIcon,
  MessageSquareText,
  Music,
  Package,
  Sparkles,
  Upload,
  UserRound,
  Video,
} from 'lucide-react'

import type { NodeCategory, StudioNodeType } from '@/features/studio/canvas/types'

export interface CanvasNodeCatalogItem {
  type: StudioNodeType
  icon: LucideIcon
  labelKey: string
}

export const CANVAS_NODE_CATALOG: { category: NodeCategory; items: CanvasNodeCatalogItem[] }[] = [
  {
    category: 'input',
    items: [
      { type: 'context', icon: BookOpen, labelKey: 'canvas.node.context' },
      { type: 'text', icon: FileText, labelKey: 'canvas.node.text' },
      { type: 'prompt', icon: MessageSquareText, labelKey: 'canvas.node.prompt' },
      { type: 'upload', icon: Upload, labelKey: 'canvas.node.upload' },
      { type: 'ref_character', icon: UserRound, labelKey: 'canvas.node.refCharacter' },
      { type: 'ref_scene', icon: MapIcon, labelKey: 'canvas.node.refScene' },
    ],
  },
  {
    category: 'generate',
    items: [
      { type: 'gen_image', icon: Image, labelKey: 'canvas.node.genImage' },
      { type: 'gen_video', icon: Video, labelKey: 'canvas.node.genVideo' },
      { type: 'gen_audio', icon: Music, labelKey: 'canvas.node.genAudio' },
    ],
  },
  {
    category: 'output',
    items: [
      { type: 'register', icon: Package, labelKey: 'canvas.node.register' },
      { type: 'export', icon: Download, labelKey: 'canvas.node.export' },
    ],
  },
  {
    category: 'container',
    items: [{ type: 'group', icon: Layers, labelKey: 'canvas.node.group' }],
  },
]

export const CANVAS_NODE_CATEGORY_ICON: Record<NodeCategory, LucideIcon> = {
  input: BookOpen,
  generate: Sparkles,
  output: Package,
  container: Layers,
}

export const CANVAS_NODE_CATEGORY_LABEL_KEY: Record<NodeCategory, string> = {
  input: 'canvas.category.input',
  generate: 'canvas.category.generate',
  output: 'canvas.category.output',
  container: 'canvas.category.container',
}
